import { useContext } from 'react'
import { CarouselContext } from './CarouselProvider'

export const useCarousel = () => {
  const context = useContext(CarouselContext)
  return context
}
